<div class="dialog-content-wrapper" style="margin: -24px;">
  <mat-toolbar matDialogTitle class="mat-indigo-800-bg m-0 customBlue">
      <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
          <span class="title dialog-title">{{translations.lblOrderSummary}}</span>
          <span class="title dialog-title"></span>
          <button mat-button class="mat-icon-button" (click)="dialogRef.close()" aria-label="Close dialog">
              <mat-icon>close</mat-icon>
          </button>
      </mat-toolbar-row>


  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar 
  style="max-height: 90vh;height: calc(90vh - 110px);padding-top: 0px !important; width: calc(80vw);">

  <div class="pies-container">
    <dx-pie-chart *ngFor="let options of pies" class="pie"
        [title]="translations[options.title]"
        [dataSource]="options.dataSource"
        [resolveLabelOverlapping]="'shift'"
        sizeGroup="piesGroup">
        <dxi-series
            argumentField="OrderType"
            valueField="val">     
            <dxo-label [visible]="true"  position="columns" [customizeText]="customizeLabel">
                <dxo-font [size]="16"></dxo-font>
                <dxo-connector
                [visible]="true"
                [width]="0.5"></dxo-connector>
            </dxo-label>       
        </dxi-series>
        <dxo-legend verticalAlignment="top"
            horizontalAlignment="right"
            itemTextPosition="right"
            >
        </dxo-legend>
    </dx-pie-chart>
</div>
  </div>

</div>


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/distributor-order/dist-summary-chart/dist-summary-chart.component.html